import * as yup from "yup";

export const accountDeletionStep2Schema = yup.object({
  email: yup
    .string()
    .required("Обязательное поле")
    .email("Неверный формат email"),
  code: yup
    .string()
    .required("Обязательное поле")
    .matches(
      /^\d+$/,
      "Код введен неверно. Убедитесь, что код подтверждения, отправленный на ваш email, соответствует введенным данным"
    )
    .length(6, "Код должен содержать 6 цифр")
    .transform((value) => (value ? String(value) : "")),
});

export type UpdateUserFormValues = yup.InferType<
  typeof accountDeletionStep2Schema
>;
